'use strict';

const MIME_BMP = 'image/bmp';
const MIME_JPEG = 'image/jpeg';
const MIME_PNG = 'image/png';

module.exports = {
  MIME_BMP,
  MIME_JPEG,
  MIME_PNG
};

